module.exports = __webpack_public_path__ + "img/Weilin Monitoring Hard Disk Software.f63c02ad.jpg";